import type { BaseIconProps } from "@/assets/icons/utils";
import type { FC } from "react";

export const IconPaperclip: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    {...props}
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    overflow="visible"
                >
                    <path
                        d="M7.71985 12.8137L12.25 8.17499"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M9.3333 4.50001L4.42516 9.50851C4.20644 9.72729 4.08357 10.024 4.08357 10.3333C4.08357 10.6427 4.20644 10.9394 4.42516 11.1582C4.64394 11.3769 4.94063 11.4998 5.24999 11.4998C5.55935 11.4998 5.85604 11.3769 6.07482 11.1582L10.983 6.14968C11.4204 5.71211 11.6662 5.11873 11.6662 4.50001C11.6662 3.88129 11.4204 3.28791 10.983 2.85034C10.5454 2.41291 9.952 2.16718 9.3333 2.16718C8.71461 2.16718 8.12122 2.41291 7.68366 2.85034L2.77491 7.85826C2.11847 8.51469 1.74969 9.40501 1.74969 10.3333C1.74969 11.2617 2.11847 12.152 2.77491 12.8084C3.43134 13.4649 4.32166 13.8336 5.24999 13.8336C6.17833 13.8336 7.06864 13.4649 7.72508 12.8084"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    {...props}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    overflow="visible"
                >
                    <path
                        d="M10.8227 15.5013L16 10.2"
                        stroke="currentColor"
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M12.6667 6.00002L7.05734 11.724C6.80737 11.9741 6.66695 12.3131 6.66695 12.6667C6.66695 13.0202 6.80737 13.3593 7.05734 13.6094C7.30737 13.8593 7.64645 13.9997 8 13.9997C8.35356 13.9997 8.69263 13.8593 8.94267 13.6094L14.552 7.88535C15.0519 7.38528 15.3328 6.70713 15.3328 6.00002C15.3328 5.29292 15.0519 4.61476 14.552 4.11469C14.0519 3.61476 13.3738 3.33392 12.6667 3.33392C11.9596 3.33392 11.2814 3.61476 10.7813 4.11469L5.17134 9.83802C4.42113 10.5882 3.99966 11.6057 3.99966 12.6667C3.99966 13.7276 4.42113 14.7451 5.17134 15.4954C5.92155 16.2456 6.93905 16.667 8 16.667C9.06096 16.667 10.0785 16.2456 10.8287 15.4954"
                        stroke="currentColor"
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        case "lg":
            return (
                <svg
                    className={className}
                    {...props}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    overflow="visible"
                >
                    <path
                        d="M12.9255 18.189L18.75 12.225"
                        stroke="currentColor"
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M15 7.49997L8.68951 13.9395C8.40831 14.2208 8.25034 14.6022 8.25034 15C8.25034 15.3977 8.40831 15.7792 8.68951 16.0605C8.97081 16.3417 9.35227 16.4996 9.75002 16.4996C10.1478 16.4996 10.5292 16.3417 10.8105 16.0605L17.121 9.62097C17.6834 9.05839 17.9994 8.29546 17.9994 7.49997C17.9994 6.70448 17.6834 5.94155 17.121 5.37897C16.5584 4.81656 15.7955 4.50061 15 4.50061C14.2045 4.50061 13.4416 4.81656 12.879 5.37897L6.56776 11.8177C5.72378 12.6617 5.24963 13.8064 5.24963 15C5.24963 16.1935 5.72378 17.3382 6.56776 18.1822C7.41175 19.0262 8.55644 19.5003 9.75002 19.5003C10.9436 19.5003 12.0883 19.0262 12.9323 18.1822"
                        stroke="currentColor"
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
    }
};
